/**
 * ajaxHandler for handling ajax request
 *
 * @since 1.0.0
 * @param {*} formData 
 * @returns json response
 */
export async function ajaxHandler(formData, jsonRes = true) {
    const { ajax_url, nonce_field, nonce_value } = vendoraObject;

    // Append nonce field to form data
    formData.append(nonce_field, nonce_value);
    try {
        const post = await fetch(ajax_url, {
            method: 'POST',
            body: formData,
        });
        if (post.ok) {
            if (jsonRes) {
                return await post.json();
            } else {
                await post.text();
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export function vendoraFormData(data = []) {
    const formData = new FormData();
    data.forEach((item) => {
        for (const [key, value] of Object.entries(item)) {
            formData.set(key, value)
        }
    });
    return formData;
}

export const spinnerElem = `<span class="vendora-spinner-border vendora-spinner-border-sm" aria-hidden="true"></span>`;

export const toast = {
    success: function (message) {
        const toastElement = this.getTemplate('primary', message);
        document.body.appendChild(toastElement);
        setTimeout(() => {
            document.body.removeChild(toastElement);
        }, 3000);
    },
    error: function (message) {
        const toastElement = this.getTemplate('danger', message);
        document.body.appendChild(toastElement);
        setTimeout(() => {
            document.body.removeChild(toastElement);
        }, 3000);
    },
    getTemplate: function (variant, message) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = `
		<div class="vendora-toast-container vendora-position-fixed vendora-bottom-0 vendora-start-0 vendora-p-3">
			<div class="vendora-toast vendora-show vendora-align-items-center vendora-toast-${variant} vendora-border-0" role="alert" aria-live="assertive" aria-atomic="true">
				<div class="vendora-d-flex">
				<div class="vendora-toast-body">
					${message}
				</div>
				<button type="button" class="vendora-btn-close vendora-btn-close-white vendora-me-2 vendora-m-auto" vendora-toast-close aria-label="Close"></button>
				</div>
			</div>
		</div>
		`
        return wrapper;
    }
};

window.toast = toast; // For tickets application

export function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        const context = this;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}

export function isMobileDevice() {
    return /Mobi|Android/i.test(navigator.userAgent);
}
